<template>
  <div>
    <v-data-table
      fixed-header
      dense
      :height="groupBy.length ? 530 : 470"
      :group-by="groupByValue"
      :custom-group="customGroupBy"
      :headers="headers"
      :items="history"
      :hide-default-footer="!!groupBy.length"
      :disable-pagination="!!groupBy.length"
      :footer-props="{
        'items-per-page-options': [20, 30, 50, -1]
      }"
    >
      <template v-slot:[`group.header`]="{ items, isOpen, toggle, headers }">
        <td
          v-if="fromRequestModule"
          :colspan="headers.length - 5"
          class="primary white--text group-td"
        >
          <div class="d-flex align-center">
            <v-btn
              icon
              small
              @click="toggle"
            >
              <v-icon color="white">
                {{ isOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
              </v-icon>
            </v-btn>
            <span class="subtitle-2 ml-2">{{ groupTitle(items[0]) }}</span>
          </div>
        </td>
        <td
          :colspan="2"
          class="primary white--text text-no-wrap px-2"
        >
          <div class="d-flex align-center">
            <span>Total: {{ totalAmount(items) }}₴</span>
          </div>
        </td>
        <td
          :colspan="3"
          class="primary white--text text-no-wrap px-2"
        >
          <div class="d-flex align-center">Amount : {{ items.length }}</div>
        </td>
      </template>
      <template v-slot:[`item.Is_Pending`]="{ item }">
        <span
          v-if="item.Is_Pending"
          class="orange--text text--darken-2"
        >
          Pending
        </span>
        <span
          v-if="!item.Is_Pending"
          class="primary--text darken-2"
        >
          Considered
        </span>
      </template>
      <template v-slot:[`item.Approved`]="{ item }">
        <span
          v-if="item.Approved && !item.Is_Pending"
          class="success--text darken-2"
        >
          Approved by {{ item.Confirmer_Full_Name }}<br>
        </span>
        <span
          v-if="!item.Approved && !item.Is_Pending"
          class="error--text darken-2"
        >
          Rejected by {{ item.Confirmer_Full_Name }}<br>
          <b>Reason: {{ item.Rejection_Reason }}</b>
        </span>
      </template>
      <template v-slot:[`item.Amount_Spent`]="{ item }">
        <span>
          {{ item.Amount_Spent + ' uah' }}
        </span>
      </template>
      <template v-slot:[`item.Agreement_File_Name`]="{ item }">
        <a
          @click="getMedicalInsuranceFile(item.Agreement_File_Name, item.Request_ID, 'Agreement_File', item.Agreement_File_Type)"
        >{{ item.Agreement_File_Name }}</a>
      </template>
      <template v-slot:[`item.Payment_Check_File_Name`]="{ item }">
        <a
          @click="getMedicalInsuranceFile(item.Payment_Check_File_Name, item.Request_ID, 'Payment_Check_File', item.Payment_Check_File_Type)"
        >{{ item.Payment_Check_File_Name }}</a>
      </template>
      <template v-slot:[`item.Other_File_Name`]="{ item }">
        <a @click="getMedicalInsuranceFile(item.Other_File_Name, item.Request_ID, 'Other_File', item.Other_File_Type)">
          {{ item.Other_File_Name }}
        </a>
      </template>
      <template v-slot:[`item.Manage`]="{ item }">
        <td class="text-center text-no-wrap">
          <v-tooltip bottom color="success">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                icon
                v-bind="attrs"
                v-on="on"
                :disabled="!item.Is_Pending"
                color="success"
                @click="openAcceptDialog(item)"
              >
                <v-icon>
                  mdi-check-circle
                </v-icon>
              </v-btn>
            </template>
            <span>Approve</span>
          </v-tooltip>
          <v-tooltip bottom color="red darken-2">
            <template v-slot:activator="{ on, attrs}">
              <v-btn
                small
                icon
                v-bind="attrs"
                v-on="on"
                :disabled="!item.Is_Pending"
                color="red darken-2"
                @click="openRejectDialog(item)"
              >
                <v-icon>
                  mdi-close-circle
                </v-icon>
              </v-btn>
            </template>
            <span>Reject</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>
    <v-dialog
      v-model="showRejectDialog"
      max-width="300px"
    >
      <v-card>
        <v-card-title>
          <v-textarea
            rows="2"
            label="Rejection reason"
            v-model="rejectionReason"
          >
          </v-textarea>
        </v-card-title>
        <v-card-actions>
          <v-btn small outlined color="primary" @click="showRejectDialog = false">
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn small :disabled="!rejectionReason" color="red darken-2 white--text" @click="considerRequest(false)">
            Reject
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmOrDeniedDialog
      v-if="showAcceptDialog"
      v-model="showAcceptDialog"
      :mode="confirmOrDeniedDialogModes.confirmation"
      :message="'Approve request?'"
      :confirmBtnName="'Approve'"
      @onApproveClick="considerRequest(true)"
      @onCancelClick="showAcceptDialog = false"
      @onCloseClick="showAcceptDialog = false"
    />
  </div>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'
export default {
  name: 'MedicalInsuranceRequestHistory',
  components: {
    ConfirmOrDeniedDialog: () => import('@/components/global/ConfirmOrDeniedDialog.vue')
  },
  props: {
    value: {
      required: true,
      default: false
    },
    employeeId: {
      required: false,
      default: null
    },
    dateFrom: {
      required: false,
      default: null
    },
    dateTo: {
      required: false,
      default: null
    },
    groupBy: {
      required: false,
      default: () => {
        return []
      }
    },
    fromRequestModule: {
      required: false,
      default: false
    },
    showListEmployee: {
      required: false,
      default: false
    }
  },
  data () {
    return {
      history: [],
      consideringRequest: null,
      showRejectDialog: false,
      showAcceptDialog: false,
      rejectionReason: null,
      downloadLink: document.createElement('a'),
      statusNames: {
        Pending: 'Pending',
        Rejected: 'Rejected',
        Approved: 'Approved'
      },
      groupByValue: [],
      groupByText: []
    }
  },
  mounted () {
    this.getHistory()
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    confirmOrDeniedDialogModes () {
      return this.$store.getters.getConfirmOrDeniedDialogModes
    },
    headers () {
      return [
        {
          text: 'Employee',
          value: 'Request_Owner',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: this.showListEmployee
        },
        {
          text: 'Created',
          value: 'Date_Of_Create',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Updated',
          value: 'Date_Of_Update',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Insurance agreement',
          value: 'Agreement_File_Name',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Payment Check',
          value: 'Payment_Check_File_Name',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Other file',
          value: 'Other_File_Name',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Confirmer',
          value: 'Confirmer_Full_Name',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: !this.fromRequestModule
        },
        {
          text: 'Amount',
          value: 'Amount_Spent',
          width: '5%',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Details',
          value: 'Details',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Status',
          value: 'Is_Pending',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Approved',
          value: 'Approved',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Manage',
          value: 'Manage',
          class: 'px-2 text-center',
          width: '50px',
          sortable: false,
          show: this.fromRequestModule
        }
      ].filter(item => item.show)
    }
  },
  methods: {
    getHistory () {
      const historyOfEmployee = this.showListEmployee ? 'none' : this.employeeId || this.user.employee_id
      this.axios.get(`/api/requests/medical_insurance/${historyOfEmployee}` +
        (this.dateFrom ? `/${this.dateFrom}` : '') +
        (this.dateTo ? `/${this.dateTo}` : ''), {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.history = res.data
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    customGroupBy (items, groupBy) {
      const groups = []
      items.forEach(item => {
        let cId = ''
        for (let i = 0; i < groupBy.length; i++) {
          cId += item[groupBy[i]]
        }
        const group = groups.find(g => g.name === cId)
        if (group) {
          group.items.push(item)
        } else {
          groups.push({
            name: cId,
            items: [item]
          })
        }
      })
      return groups
    },
    groupTitle (item) {
      let str = ''
      for (let i = 0; i < this.groupBy.length; i++) {
        str += item[this.groupBy[i].value] ? item[this.groupBy[i].value] + (i === this.groupBy.length - 1 ? '' : ', ') : 'Other' + (i === this.groupBy.length - 1 ? '' : ', ')
      }
      return str
    },
    totalAmount (items) {
      return items.reduce((total, item) => {
        return total + item.Amount_Spent
      }, 0)
    },
    linkToFile (data, type) {
      let res = ''
      let binary = ''
      const bytes = new Uint8Array(data)
      const len = bytes.byteLength
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i])
      }
      res = `data:${type};base64, ${window.btoa(binary)}`
      return res
    },
    openFile (filename, data, type) {
      const linkSource = this.linkToFile(data, type)
      this.downloadLink.href = linkSource
      this.downloadLink.download = filename
      this.downloadLink.click()

      setTimeout(() => {
        this.downloadLink.href = ''
      })
    },
    getMedicalInsuranceFile (filename, requestId, kindOfFile, typeOfFile) {
      this.axios.get(`/api/requests/medical_insurance_file/${requestId}/${kindOfFile}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.openFile(filename, res.data[0].File.data, typeOfFile)
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    openRejectDialog (item) {
      this.consideringRequest = item
      this.showRejectDialog = true
    },
    openAcceptDialog (item) {
      this.consideringRequest = item
      this.showAcceptDialog = true
    },
    considerRequest (approved) {
      this.axios.put('/api/requests/consider_medical_insurance',
        {
          Request_ID: this.consideringRequest.Request_ID,
          Approved: approved,
          Rejection_Reason: this.rejectionReason
        },
        {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(() => {
        if (approved) {
          this.consideringRequest.Approved = 1
          this.consideringRequest.Status = this.statusNames.Approved
        } else {
          this.consideringRequest.Rejection_Reason = this.rejectionReason
          this.consideringRequest.Approved = 0
          this.consideringRequest.Status = this.statusNames.Rejected
        }
        this.consideringRequest.Confirmer_Full_Name = this.user.full_name
        this.consideringRequest.Is_Pending = 0
        this.consideringRequest.Date_Of_Update = 'just now'
        this.$store.dispatch('setSuccess', { successMsg: 'Request was ' + (approved ? 'approved' : 'rejected') })
        this.showAcceptDialog = this.showRejectDialog = false
        this.$emit('actionOnRequest', {
          approved,
          requestOwner: this.consideringRequest.Creator_ID
        })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    }
  },
  watch: {
    showRejectDialog (val) {
      if (!val) {
        this.rejectionReason = null
      }
    },
    groupBy: {
      handler (val, oldVal) {
        this.groupByValue = val.map(el => el.value)
        this.groupByText = val.map(el => el.text)
      },
      deep: true
    }
  }
}
</script>
